import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector, reset, change } from "redux-form";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import FormControl from "react-bootstrap/lib/FormControl";

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import HouseRules from './HouseRules';
import Loader from '../../Loader';
import Link from '../../Link';
import ModalForm from './ModalForm/ModalForm';

// Helpers
import showToaster from "../../../helpers/showToaster";
import validate from './validate';
import fetch from '../../../core/fetch';
import messages from '../../../locale/messages';
import { isRTL } from '../../../helpers/formatLocale';
// Locale
import { makePayment } from '../../../actions/booking/makePayment';
import { submitBookingRequest } from '../../../actions/booking/submitBookingRequest';
import { processCardAction } from '../../../actions/PaymentIntent/processCardAction';
import { openPaymentModal } from '../../../actions/modalActions';

//Images
import { LinkIndicateIcon } from "../../Common/Assets/SvgComponent/commonSvgIcon";
import defaultPic from '/public/SiteImages/defaultPic.png';

import { COMMON_TEXT_COLOR, DARK_COMMON_TEXT_COLOR, DARK_PLACEHOLDER_COLOR, PLACEHOLDER_COLOR } from "../../../constants";
import bt from '../../../components/commonStyle.css';
import s from './Payment.css';

const createOptions = (theme, isRTLLocale) => {
  return {
    style: {
      base: {
        color: theme == "dark" ? DARK_COMMON_TEXT_COLOR : COMMON_TEXT_COLOR,
        fontWeight: 400,
        fontFamily: "inherit",
        fontSize: "14px",
        textAlign: isRTLLocale ? "right" : "left",
        fontSmoothing: "antialiased",
        ":focus": {
          color: theme == "dark" ? DARK_COMMON_TEXT_COLOR : COMMON_TEXT_COLOR
        },

        "::placeholder": {
          color: theme == "dark" ? DARK_PLACEHOLDER_COLOR : PLACEHOLDER_COLOR
        },

        ":focus::placeholder": {
          color: theme == "dark" ? DARK_PLACEHOLDER_COLOR : PLACEHOLDER_COLOR
        },
      },
      invalid: {
        color: theme == "dark" ? DARK_COMMON_TEXT_COLOR : COMMON_TEXT_COLOR,
        ":focus": {
          color: theme == "dark" ? DARK_COMMON_TEXT_COLOR : COMMON_TEXT_COLOR
        },
        "::placeholder": {
          color: theme == "dark" ? DARK_PLACEHOLDER_COLOR : PLACEHOLDER_COLOR
        },
      },
    },
  };
};
class PaymentForm extends Component {
  static propTypes = {
    houseRules: PropTypes.arrayOf(
      PropTypes.shape({
        listsettings: PropTypes.shape({
          itemName: PropTypes.string.isRequired,
        }),
      })
    ),
    hostDisplayName: PropTypes.string.isRequired,
    isHostPictureMigrated: PropTypes.bool,
    allowedPersonCapacity: PropTypes.number.isRequired,
    initialValues: PropTypes.shape({
      listId: PropTypes.number.isRequired,
      listTitle: PropTypes.string.isRequired,
      hostId: PropTypes.string.isRequired,
      guestId: PropTypes.string.isRequired,
      checkIn: PropTypes.object.isRequired,
      checkOut: PropTypes.object.isRequired,
      guests: PropTypes.number.isRequired,
      basePrice: PropTypes.number.isRequired,
      cleaningPrice: PropTypes.number.isRequired,
      taxPrice: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      weeklyDiscount: PropTypes.number,
      monthlyDiscount: PropTypes.number,
      paymentType: PropTypes.number,
    }).isRequired,
    paymentCurrencyList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        symbol: PropTypes.string.isRequired,
        isEnable: PropTypes.bool.isRequired,
        isPayment: PropTypes.bool.isRequired,
      })
    ),
    paymentLoading: PropTypes.bool,
    formatMessage: PropTypes.any,
    additionalRules: PropTypes.string,
  };

  static defaultProps = {
    paymentCurrencyList: [],
    paymentLoading: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      paymentStatus: 2,
      load: true,
      personCapacityData: [],
    };
  }

  UNSAFE_componentWillMount() {
    const { listingFields, stripePayment } = this.props;
    if (listingFields != undefined) {
      this.setState({ personCapacityData: listingFields.personCapacity });
    }
    this.setState({ paymentStatus: !stripePayment ? 1 : 2 });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;
    if (listingFields != undefined) {
      this.setState({ personCapacityData: listingFields.personCapacity });
    }
  }

  componentDidUpdate(prevProps) {
    const { locale } = this.props.intl;
    const { locale: prevLocale } = prevProps.intl;

    if (locale !== prevLocale) {
      this.setState({ load: false });
      clearTimeout(this.loadSync);
      this.loadSync = null;
      this.loadSync = setTimeout(() => this.setState({ load: true }), 1);
    }
  }

  renderFormControlSelect = ({
    input,
    label,
    meta: { touched, error },
    children,
    className,
    disabled,
  }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl
          disabled={disabled}
          componentClass="select"
          {...input}
          className={className}
        >
          {children}
        </FormControl>
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
      </div>
    );
  };

  renderFormControlTextArea = ({
    input,
    label,
    meta: { touched, error },
    children,
    className,
  }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl
          {...input}
          className={className}
          componentClass="textarea"
          placeholder={label}
        >
          {children}
        </FormControl>
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
      </div>
    );
  };

  renderGuests(personCapacity) {
    const { formatMessage } = this.props.intl;
    const { personCapacityData } = this.state;

    let rows = [], i;
    for (i = 1; i <= personCapacity; i++) {
      rows.push(
        <option key={i} value={i}>
          {i}{" "}
          {i > 1
            ? personCapacityData[0]?.otherItemName
            : personCapacityData[0]?.itemName}
        </option>
      );
    }
    return rows;
  }

  renderpaymentCurrencies = () => {
    const { paymentCurrencyList } = this.props;
    let rows = [];

    if (paymentCurrencyList != null && paymentCurrencyList?.length > 0) {
      paymentCurrencyList?.map((item, index) => {
        if (item?.isEnable && item?.isPayment) {
          rows.push(
            <option key={index} value={item?.symbol}>
              {item?.symbol}
            </option>
          );
        }
      });
    }
    return rows;
  };
  renderFormControl = ({
    input,
    label,
    type,
    placeholder,
    meta: { touched, error },
    className,
  }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl
          {...input}
          placeholder={placeholder}
          type={type}
          className={className}
          maxLength={11}
        />
        {touched && error && (
          <span className={s.errorMessage}>{formatMessage(error)}</span>
        )}
      </div>
    );
  };

  handleClick = () => {
    const { dispatch } = this.props;
    dispatch(reset("BookingForm"));
  };

  handleSubmit = async (values, dispatch) => {
    const { stripe, processCardAction, elements } = this.props;

    let paymentType, paymentCurrency, query;
    paymentType = values?.paymentType;
    paymentCurrency = values?.paymentType == 1 ? values?.paymentCurrency : null;

    if (values?.isHostServiceEligible) {
      showToaster({ messageId: 'hostServiceFeeGreater', toasterType: 'error' })
      return;
    }

    query = `query checkReservation ($checkIn: String,$checkOut: String,$listId: Int ){
      checkReservation(checkIn: $checkIn, checkOut:$checkOut, listId:$listId ){
        id
        listId
        hostId
        guestId
        checkIn
        checkOut
        status
      }
    }`;

    values.checkIn = moment(values?.checkIn).format("YYYY-MM-DD");
    values.checkOut = moment(values?.checkOut).format("YYYY-MM-DD");

    const params = {
      listId: values?.listId,
      checkIn: values?.checkIn,
      checkOut: values?.checkOut,
    };

    const resp = await fetch("/graphql", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query,
        variables: params,
      }),
      credentials: "include",
    });

    const { data } = await resp.json();

    if (data?.checkReservation?.status == "200") {
      // Dates are available, proceed with booking request
      const result = await dispatch(submitBookingRequest(
          Number(values?.listId),
          values?.listTitle,
          values?.hostId,
          values?.guestId,
          values?.checkIn,
          values?.checkOut,
          values?.guests,
          values?.message || "",
          values?.basePrice,
          values?.cleaningPrice,
          values?.taxPrice,
          values?.currency,
          values?.discount,
          values?.discountType,
          values?.guestServiceFee,
          values?.hostServiceFee,
          values?.total,
          'request', // bookingType
          values?.specialPricing,
          values?.isSpecialPriceAssigned,
          values?.isSpecialPriceAverage,
          values?.dayDifference,
          values?.taxRate,
          values?.checkInStart,
          values?.checkInEnd,
          values?.hostServiceFeeType,
          values?.hostServiceFeeValue,
          values?.threadId,
          values?.guestServiceFeeType,
          values?.guestServiceFeeValue,
          values?.extraGuestFeeAmount,
          values?.extraGuestCount,
          values?.extraGuestFee,
          values?.cautionDeposit
        ));

        
        if (result && result.status === 200) {
          // Booking request submitted successfully - redirect to itinerary
          window.location.href = `/inbox`;
        }
    } else {
      showToaster({ messageId: 'checkAvailableDates', toasterType: 'error' })
    }
  };

  handlePayment = (e) => {
    const { change } = this.props;
    let paymentType = e.target.value;

    if (paymentType == 2) {
      this.setState({ paymentStatus: 2 });
    } else {
      change("zipcode", null);
      this.setState({ paymentStatus: 1 });
    }
  };

  render() {
    const { hostDisplayName, houseRules, hostPicture, hostProfileId, isPreApprove, paymentLoading, intl: { locale }, maximumStay, theme, isHostPictureMigrated } = this.props;
    const { handleSubmit, submitting, error, pristine, paymentType, restrictEdit, listId, checkIn, checkOut, guests, openPaymentModal, additionalRules } = this.props;
    const { paymentStatus, load } = this.state;
    const { formatMessage } = this.props.intl;

    let checkInDate, checkOutDate, paymentModalInitialValues;
    checkInDate =
      checkIn != null
        ? moment(moment(checkIn).format("YYYY-MM-DD")).format("DD/MM/YYYY")
        : "";
    checkOutDate =
      checkOut != null
        ? moment(moment(checkOut).format("YYYY-MM-DD")).format("DD/MM/YYYY")
        : "";
    paymentModalInitialValues = {
      checkIn,
      checkOut,
      guests,
    };

    return (
      <div
        className={cx(
          s.bookItPanel,
          s.spaceTop2,
          s.aboutNoMargin,
          "customRatioButton"
        )}
      >
        <ModalForm listId={listId} initialValues={paymentModalInitialValues} />
        <form id="payment-form" onSubmit={handleSubmit(this.handleSubmit)}>
          <h1 className={s.titleText}>
            <FormattedMessage {...messages.reviewAndPay} /> 
          </h1>
          <div>
            <div className={s.flex}>
              <div>
                <div className={s.dateTitle}>
                  <FormattedMessage {...messages.dates} />
                </div>
                <div className={cx(s.showDate)}>
                  {checkInDate}
                  {" - "}
                  {checkOutDate}
                </div>
              </div>
              {/*!restrictEdit && (
                <div>
                  <div>
                    <a
                      onClick={() => openPaymentModal()}
                      className={s.editCss}
                    >
                      <span>
                        <FormattedMessage {...messages.editLabel} />
                      </span>{" "}
                      <LinkIndicateIcon className={cx(s.editIcon, "editIconPayRTL")} />

                    </a>
                  </div>
                </div>
              )*/}
            </div>
            <div className={cx(s.flex, s.marginTop)}>
              <div>
                <div className={s.dateTitle}>
                  <FormattedMessage {...messages.guests} />
                </div>
                <div className={cx(s.showDate)}>
                  {guests}{" "}
                  {guests > 1 ? (
                    <FormattedMessage {...messages.guests} />
                  ) : (
                    <FormattedMessage {...messages.guest} />
                  )}
                </div>
              </div>
              {/*!restrictEdit && (
                <div>
                  <div>
                    <a
                      onClick={() => openPaymentModal()}
                      className={s.editCss}
                    >
                      <span>
                        <FormattedMessage {...messages.editLabel} />
                      </span>{" "}
                      <LinkIndicateIcon className={cx(s.editIcon, "editIconPayRTL")} />
                    </a>
                  </div>
                </div>
              )*/}
            </div>
            <div className={s.commonBorder}></div>
          </div>

          {houseRules?.length > 0 && (
            <div className={s.space4}> 
              <HouseRules
                hostDisplayName={hostDisplayName}
                houseRules={houseRules}
              />
              {additionalRules && <div className={s.listingFontSize} style={{whiteSpace: 'pre-wrap', marginTop: 25}}>{additionalRules}</div>}
              <div className={s.commonBorder}></div>
            </div>
          )}

          <div className={cx(s.textLeft, "textAlignRightRtl")}>
            <div className={cx(s.h3, s.bold)}>
              <FormattedMessage {...messages.aboutYourTrip} />
            </div>
            <div className={s.aboutPaymentDesc}>
              <FormattedMessage {...messages.aboutDescPayment} />
            </div>
            <div className={s.hostFlex}>
              <Link to={"/users/show/" + hostProfileId}>
                {
                  <img
                    src={isHostPictureMigrated && hostPicture ? hostPicture
                      :
                      hostPicture
                        ? "/images/avatar/medium_" + hostPicture
                        : defaultPic
                    }
                    className={s.avatarImage}
                  />
                }
              </Link>
              <div className={cx(s.messageSection)}>
                <span>
                  <FormattedMessage {...messages.hostedBy} />
                </span>{" "}
                <span>{hostDisplayName}</span>
              </div>
            </div>
            <div>
              <Field
                className={cx(s.textArea, bt.commonControlTextArea)}
                name="message"
                component={this.renderFormControlTextArea}
                label={formatMessage(messages.descriptionInfo)}
              />
            </div>
            <div className={s.commonBorder}></div>
          </div>
          <Col
            md={10}
            className={cx(s.textLeft, "textAlignRightRtl", s.noPadding)}
          >
           
            <Row className={s.space4}>
              <Col xs={12}>
                <div>
                  <h4><FormattedMessage {...messages.sendBookingRequest} /></h4>
                  <p className={s.textLight}>
                    <FormattedMessage {...messages.bookingRequestExplanation} />
                  </p>
                </div>
              </Col>
            </Row>



            <div className={s.footerBtns}>
              {!paymentLoading && (
                <div className={cx(s.cancelBtn, 'cancelBtnPaymentForm')}>
                  <Link
                    to={"/rooms/" + listId}
                    className={cx(bt.btnPrimaryBorder, s.cancelBtnLineHeight)}
                    onClick={this.handleClick}
                  >
                    <FormattedMessage {...messages.cancel} />
                  </Link>
                </div>
              )}
              {paymentLoading && (
                <div className={cx(s.cancelBtn, 'cancelBtnPaymentForm')}>
                  <a
                    href="javascript:void(0)"
                    className={cx(bt.btnPrimaryBorder, s.cancelBtnLineHeight, {
                      [s.disabledLink]: submitting == true,
                    })}
                  >
                    <FormattedMessage {...messages.cancel} />
                  </a>
                </div>
              )}
              <div className={cx(s.cancelBtn, 'cancelBtnPaymentForm')}>
                <Loader
                  type={"button"}
                  buttonType={"submit"}
                  className={cx(bt.btnPrimary, s.cancelBtnLineHeight, bt.loaderButtonFlex)}
                  disabled={submitting || error || maximumStay}
                  show={paymentLoading}
                  label={formatMessage(messages.sendBookingRequest)}
                />
              </div>
            </div>
          </Col>
        </form>
      </div>
    );
  }
}

PaymentForm = reduxForm({
  form: "PaymentForm", // a unique name for this form
  validate,
  enableReinitialize: true,
})(PaymentForm);

// Decorate with connect to read form values
const selector = formValueSelector("PaymentForm"); // <-- same as form name

const mapState = (state) => ({
  paymentCurrencyList: state?.currency?.availableCurrencies?.results,
  paymentLoading: state?.book?.paymentLoading,
  paymentType: selector(state, "paymentType"),
  listingFields: state?.listingFields?.data,
  checkIn: selector(state, "checkIn"),
  checkOut: selector(state, "checkOut"),
  guests: Number(selector(state, "guests")),
  maximumStay: state?.viewListing?.maximumStay,
  restrictEdit: state?.book?.restrictEdit,
  theme: state?.currency?.theme,
});

const mapDispatch = {
  // makePayment,
  submitBookingRequest,
  processCardAction,
  openPaymentModal,
  change
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(PaymentForm)))
